import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { MyBuysContainerProps } from "../../../interfaces/containers";
import EntryPoint from "../../../pages/Profile/MyBuys/EntryPoint";
import { getMyBuysRequest, cleanMyBuys } from "../../../actions/profile";
import { getPaymentProcess, getDataPayment } from "../../../actions/linzeCheck";
import { getReservePublicationId, getCancellationPayment } from "../../../actions/publication";

function mapStateToProps(state: MyBuysContainerProps) {
    return{
        fetchingMyBuys: state.profile.fetchingMyBuys,
        myBuys: state.profile.myBuys,
        totalBuys: state.profile.totalBuys,
        user: state.auth?.user,
        dataPayment: state.report?.dataPayment,
        reservar: state.publication?.reserve,
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getMyBuysRequest,
        cleanMyBuys,
        getPaymentProcess,
        getDataPayment,
        getReservePublicationId,
        getCancellationPayment,
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(EntryPoint);